import * as types from './types'

export default {
  [types.SET_MESSAGE](state, data) {
    state.message = data
  },
  [types.SET_MESSAGES](state, data) {
    state.messages = data
  },
  [types.SET_MESSAGE_COUNTS_WORKORDER](state, data) {
    state.messageCountsWorkOrder = data
  },
  [types.SET_WORK_ORDER_MESSAGES](state, data) {
    state.workOrderMessages = data
  },
  [types.SET_ALL_MESSAGES](state, data) {
    state.messages = {
      count: 0,
      items: []
    }
    if (data) {
      if (data[0].Pager) {
        state.messages.count = data[0].Pager[0].TotalItems
      }
      if (data[0].Messages) {
        state.messages.items = data[0].Messages
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/mutations.js